<nwm-menu />
<div class="main content">
  <div class="row no-gutters mb-5 mt-4">
    <div class="col-xxl-10 offset-xxl-1">
      <h1 class="mt-4 mb-2">Notifications</h1>
      <div class="scrollable-wrap mt-3">
        <div class="scrollable">
          <div class="scrollable-button left"></div>
          <div class="scrollable-button"></div>
          <table width="100%" class="NWMtable sticky_header">
            <thead>
              <tr>
                <td width="30">&nbsp;</td>
                <td>Message</td>
                <td width="140" align="center">Date</td>
              </tr>
            </thead>
            @if (totalRows>0) {
              <tbody>
                @for (m of messages; track m; let i = $index) {
                  <tr [ngClass]="{'expanded':m.expanded}" (click)="expand(m)" style="cursor:pointer">
                    <td class="arrow"></td>
                    <td>
                      @if (m.KYClink && m.expanded && auth.hasAccess('Edit_KYC')) {
                        <button class="btn-primary px-4 pull-right mt-2" (click)="auth.openKYC()" click-stop-propagation>Review KYC</button>
                      }
                      <div class="notification-title" [ngClass]="{'font-weight-bold':!m.Viewed}">{{m.Title}}</div>
                      <div class="notification-preview">{{m.Preview}}</div>
                      <div class="notification-text mt-1" [innerHTML]="m.Text"></div>
                    </td>
                    <td class="text-right">{{ m.AssignedToUser | date:'MMM d, yyyy'}}</td>
                  </tr>
                }
              </tbody>
            }
            @if (totalRows<1) {
              <tbody>
                <td></td><td class="text-center p-4"><i>You have no new notifications.</i></td><td></td>
              </tbody>
            }
          </table>
        </div>

      </div>

      @if (totalPages > 1) {
        <ngb-pagination [collectionSize]="totalRows"
          [(page)]="page" [maxSize]="5" (pageChange)="loadPage()"
          class="float-right pagination"
          [pageSize]="pageSize"
          [boundaryLinks]="true" />
        }

      </div>
    </div>
  </div>